var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_16018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2846 0.572266H1.71317C1.41007 0.572266 1.11937 0.692673 0.905048 0.907001C0.69072 1.12133 0.570313 1.41202 0.570312 1.71512V14.2866C0.570313 14.5897 0.69072 14.8803 0.905048 15.0947C1.11937 15.309 1.41007 15.4294 1.71317 15.4294H14.2846C14.5877 15.4294 14.8784 15.309 15.0927 15.0947C15.307 14.8803 15.4275 14.5897 15.4275 14.2866V1.71512C15.4275 1.41202 15.307 1.12133 15.0927 0.907001C14.8784 0.692673 14.5877 0.572266 14.2846 0.572266Z",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 0.572266V3.00884C7.75311 2.78821 7.44786 2.64368 7.12088 2.59272C6.79389 2.54175 6.45914 2.58652 6.15704 2.72162C5.85493 2.85672 5.59839 3.07637 5.41838 3.35406C5.23837 3.63176 5.14258 3.95562 5.14258 4.28655C5.14258 4.61749 5.23837 4.94135 5.41838 5.21904C5.59839 5.49673 5.85493 5.71639 6.15704 5.85148C6.45914 5.98658 6.79389 6.03135 7.12088 5.98039C7.44786 5.92942 7.75311 5.7849 7.99976 5.56427V10.4374C8.24642 10.2168 8.55167 10.0723 8.87865 10.0213C9.20564 9.97032 9.54039 10.0151 9.84249 10.1502C10.1446 10.2853 10.4011 10.5049 10.5812 10.7826C10.7612 11.0603 10.857 11.3842 10.857 11.7151C10.857 12.0461 10.7612 12.3699 10.5812 12.6476C10.4011 12.9253 10.1446 13.145 9.84249 13.2801C9.54039 13.4152 9.20564 13.4599 8.87865 13.409C8.55167 13.358 8.24642 13.2135 7.99976 12.9928V15.4294",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 8.00172H3.00688C2.78625 8.24837 2.64173 8.55362 2.59076 8.88061C2.5398 9.20759 2.58457 9.54234 2.71966 9.84445C2.85476 10.1465 3.07442 10.4031 3.35211 10.5831C3.6298 10.7631 3.95366 10.8589 4.2846 10.8589C4.61553 10.8589 4.93939 10.7631 5.21709 10.5831C5.49478 10.4031 5.71443 10.1465 5.84953 9.84445C5.98463 9.54234 6.0294 9.20759 5.97843 8.88061C5.92747 8.55362 5.78294 8.24837 5.56231 8.00172H10.4355C10.2148 7.75506 10.0703 7.44982 10.0193 7.12283C9.96837 6.79584 10.0131 6.46109 10.1482 6.15899C10.2833 5.85689 10.503 5.60034 10.7807 5.42033C11.0584 5.24032 11.3822 5.14453 11.7132 5.14453C12.0441 5.14453 12.368 5.24032 12.6457 5.42033C12.9234 5.60034 13.143 5.85689 13.2781 6.15899C13.4132 6.46109 13.458 6.79584 13.407 7.12283C13.356 7.44982 13.2115 7.75506 12.9909 8.00172H15.4275",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_16018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/resources-icon.4e6c0ab9c1213b5bdd5033ac5c42dedb.svg";
export { ForwardRef as ReactComponent };